"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.loadOrders = function (queryParameters) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_ORDERS
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getOrders(auth, queryParameters);
  });
};

exports.loadOrder = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_ORDER,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getOrder(auth, id);
  });
};

exports.createOrder = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.CREATE_ORDER
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.postOrder(auth, data);
  });
};

exports.updateOrder = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_ORDER
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putOrder(auth, data);
  });
};

exports.submitOrder = function (id, data) {
  if (data === void 0) {
    data = {};
  }

  return actionCreator_1.apiAction({
    type: actionTypes_1.SUBMIT_ORDER,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putOrderAction(auth, id, 'submit', data);
  });
};

exports.reserveOrder = function (id, data) {
  if (data === void 0) {
    data = {};
  }

  return actionCreator_1.apiAction({
    type: actionTypes_1.SUBMIT_ORDER,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putOrderAction(auth, id, 'reserve', data);
  });
};